import { useTheme } from '@emotion/react';

import InfoIcon from '@app/assets/icons/InfoIcon';
import ErrorIcon from '@app/components/Alert/ErrorIcon';
import SuccessIcon from '@app/components/Alert/SuccessIcon';
import WarningIcon from '@app/components/Alert/WarningIcon';
import { rem } from '@app/styles/theme/layout';

const StatusIcon = ({
  type,
  fill,
  width,
}: {
  type: string;
  fill?: string;
  width?: string;
}) => {
  const theme = useTheme();

  switch (type) {
    case 'success':
      return (
        <SuccessIcon
          fill={fill ?? theme.colors.success}
          width={width ?? rem(20)}
        />
      );
    case 'warning':
      return (
        <WarningIcon
          fill={fill ?? theme.colors.warning}
          width={width ?? rem(20)}
        />
      );
    case 'error':
      return (
        <ErrorIcon fill={fill ?? theme.colors.error} width={width ?? rem(20)} />
      );
    default:
      return (
        <InfoIcon fill={fill ?? theme.colors.info} width={width ?? rem(20)} />
      );
  }
};

export default StatusIcon;
